<template>
  <header>
    <nav class="container">
      <div class="nav-links">
        <router-link to="/suche">Gegenstände</router-link>
        <router-link to="/funktionstest">Funktionstests</router-link>
        <router-link to="/klasse">Klassen</router-link>
        <router-link to="/verfahren">Verfahren</router-link>
        <router-link to="/standort">Standorte</router-link>
        <router-link to="/lieferschein/create" style="position: relative">
          <ui-icon icon="local_shipping" />
          <span class="count-indicator" v-if="numberOfShippingItems > 0">{{ numberOfShippingItems }}</span>
        </router-link>
        <router-link to="/papierkorb" v-if="isInStammdaten">
          <ui-icon icon="delete_outline" />
        </router-link>
      </div>
      <div class="nav-user-info">
        <a ref="tgl-user-menu" class="tgl-user-menu">{{ username }}</a>
        <div class="user-img">
          <span id="profileImg" />
        </div>
        <ui-popover ref="userMenuPopover" trigger=".tgl-user-menu">
          <ui-menu :options="userMenuOptions" @select="menuSelected" @close="$refs.userMenuPopover.close()" />
        </ui-popover>
      </div>
    </nav>
  </header>
</template>
<script>
export default {
  name: 'SiteNavigation',
  props: {
    username: { type: String }
  },
  data() {
    return {
      userMenuOptions: ['Logout']
    };
  },
  mounted() {
    this.$azure.getImage().then(img => {
      document
        .getElementById('profileImg')
        .setAttribute('style', "background-image: url('" + img + "')");
    });
  },
  methods: {
    menuSelected(option) {
      if (option === 'Logout') {
        this.logout();
      }
    },
    logout() {
      this.$azure.logout(() => {
        window.location = '/';
      });
    }
  },
  computed: {
    shippingItems() {
      return this.$store.state.shippingItems;
    },
    numberOfShippingItems() {
      return this.$store.getters.numberOfShippingItems;
    }
  },
  asyncComputed: {
    async isInStammdaten() {
      return (
        (await this.$azure.isInGroupAsync('taz-eq-stammdaten')) ||
        process.env.NODE_ENV == 'development'
      );
    }
  }
};
</script>

<style>
.nav-user-info {
  color: #9a9a9a;
  display: flex;
  align-items: center;
}

.user-img span {
  background-size: 98%;
  background-position: 50% 30%;
  background-repeat: no-repeat;
  border-radius: 50%;
  display: inline-block;
  width: 36px;
  height: 36px;
  margin-left: 1rem;
}

nav {
  display: flex;
}

.nav-links {
  flex: 1;
}

nav a {
  color: #9a9a9a;
  display: inline-block;
  max-height: 53px;
  padding: 1rem;
  text-decoration: none;
}

nav a.router-link-active {
  border-bottom: 3px solid #098;
  color: #6a6a6a;
}

.count-indicator {
  position: absolute;
  font-size: 11px;
  background-color: #c24;
  color: #fafafa;
  padding: 0.2rem 0.4rem;
  border-radius: 2rem;
  font-weight: 600;
  top: 6px;
  left: 30px;
}
</style>
